<section class="tt-ai-chat" aria-label="AI chat">
    <tt-ai-chat-header
        [selectedChat]="selectedChat"
        [selectedModelKeyno]="selectedModelKeyno"
        [showChats]="(conversationDrawer.state$ | async) ?? false"
        [canEditConfiguration]="panel.canEditAiConfiguration"
        [canOpenInModal]="canOpenInModal"
        (toggleChats)="toggleConversationDrawer()"
        (newChat)="startNewConversation()"
        (openInModal)="openInModal()"
    ></tt-ai-chat-header>

    <div class="tt-ai-chat__body">
        <tt-side-drawer-container>
            <tt-side-drawer #conversationDrawer="sideDrawer" ttMode="over" ttWidth="25rem">
                <tt-ai-chat-conversation-list
                    [chats]="(chats$ | async) ?? []"
                    [selectedChat]="selectedChat"
                    [loading]="loading"
                    (chatSelected)="selectConversation($event)"
                ></tt-ai-chat-conversation-list>
            </tt-side-drawer>

            <div class="tt-ai-chat__body-content">
                <tt-ai-chat-workspace
                    [selectedConversation]="selectedChat"
                    [messages]="(messages$ | async) ?? []"
                    [loading]="loading"
                    [loadingMessages]="loadingMessages"
                    [sending]="sending"
                ></tt-ai-chat-workspace>

                <tt-toast *ngIf="errorMessage" role="alert" ttType="danger" ttTitle="AI chat" ttTranslateTitle="false" [ttMessage]="errorMessage" ttTranslateMessage="false"></tt-toast>

                <tt-ai-chat-composer
                    [models]="(models$ | async) ?? []"
                    [selectedModelKeyno]="selectedModelKeyno"
                    (selectedModelKeynoChange)="selectModel($event)"
                    [intelligenceLevels]="intelligenceLevels"
                    [loadingIntelligenceLevels]="loadingIntelligenceLevels"
                    [(selectedIntelligenceLevel)]="selectedIntelligenceLevel"
                    [(prompt)]="prompt"
                    [loading]="loading"
                    [sending]="sending"
                    (imageUploadError)="showError($event)"
                    (submitPrompt)="sendPrompt($event)"
                ></tt-ai-chat-composer>
            </div>
        </tt-side-drawer-container>
    </div>
</section>
